import { Record } from 'immutable';

export default Record( { x: 0, y: 0 } );
